import "./SocialField.css"
import React from 'react'
import { SocialIcon } from 'react-social-icons';


export default function SocialField() {
    return (
        <div className="socialfield">
             <SocialIcon className="ico" url="https://discord.gg/GQV3qu5apn"/>
             <SocialIcon className="ico" url="mailto:teknowar42@gmail.com"/>
             <SocialIcon className="ico" url="https://github.com/kaankarakoc42"/>
             <SocialIcon className="ico" url="https://kaankarakoc42.medium.com/" bgColor="#f9f9f9"/>
        </div>
    )
}
